<!--任务分解基本信息-->
<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon" /><span class="title-details">基本信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :disabled="!isEdit"
          :showBtn="showBtn"
          @getProjectId="handleProjectId"
          @getProjectNode="handleProjectNode"
        />
      </div>
      <folded-panel infoName="工作内容">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.bsPerformanceCompositionList"
            :editable="isEdit"
            :showAdd="isEdit"
            :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
            :border="true"
            :data.sync="tableData"
            ref="delRew"
            height=""
          >
            <template #taskNodeCode="{$index}">
              <div>{{form.projectNodeCode?`${form.projectNodeCode}.${$index+1}`:''}}</div>
            </template>
            <template #taskState="{row}">
              <div>{{row.taskState ? row.taskState: row.taskStat='已分配'}}</div>
            </template>
            <template #taskReceiverObj="{row}">
              <div>{{row.taskReceiverObj ? row.taskReceiverObj.name: ''}}</div>
            </template>
            <template #taskReceiverObjEdit="{row}">
              <data-box
                hostUrl="/bs-person/getList"
                :props="{label: 'name',value: 'id'}"
                v-model="row.taskReceiverObj"
                :tableColumn="dataBoxHead"
                :multiple="false"
                @confirm="val => { row.taskReceiver = val.id }"
              />
            </template>
            <template #toolbar="scope">
              <div v-if="!isEdit">无</div>
              <el-popover :ref="scope.$index" placement="top" width="180" v-if="isEdit">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index].doClose()">取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="subDelete(scope.row.id,scope)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" v-if="isEdit" @click="submit(2)">提交</el-button>
        <el-button class="btn-submit" v-if="isEdit" @click="save(1)">保存</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import FoldedPanel from "@/components/FoldedPanel"
  import "@/components/dynamic-form"
  import '@/components/EditDataTable'
  import DataTableMixin from '@/mixins/DataTableMixin'
  import { parseTime } from "@/utils"
  import { add, edit, delForm, queryById, findProjectNodeInfo } from '@/api/bill/taskDecomposition'
  import DataBox from '@/components/dynamic-form/dynamic-data-box'
  import { getDocumentCode } from '@/views/utils'

  export default {
    name: "NewCustomer",
    components: { FoldedPanel, DataBox },
    mixins: [DataTableMixin],
    data() {
      return {
        delLoading: false,
        isEdit: false,
        tableData: [],
        dataBoxHead: [
          { label: "编码", property: "code" },
          { label: "名称", property: "name" ,query: { type: "input" } },
          { label: "备注", property: "remark" },
        ],
        formConfig: {
          formItemList: [
            {
              type: "input",
              key: "code",
              label: "单据号",
              value: "",
              disabled: true,
              span: 8,
            },
            {
              type: "databox",
              key: "projectId",
              label: "项目号",
              placeholder: "请选择项目",
              value: "",
              span: 8,
              props: {
                label: "code",
                value: ""
              },
              url: "/bizTaskDecomposition/findProject",
              tableColumn: [
                {
                  property: "code",
                  label: "项目号",
                  query: {
                    type: "input"
                  }
                },
                {
                  property: "name",
                  label: "项目名称",
                  query: {
                    type: "input"
                  }
                }
              ],
              extendParms: { queryFieldItem: "id,number,name" },
              multiple: false
            },
            // 提交日期
            {
              span: 8,
              label: '提交日期',
              key: 'commitTime',
              type: 'date',
              disabled: true,
            },
            // 项目阶段	基础资料《项目阶段》
            {
              label: '项目阶段',
              key: 'projectStage',
              type: 'databox',
              disabled: true,
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: { queryFieldItem: 'id,number,name' },
              multiple: false,
            },
            // 计划节点	基础资料《计划节点》
            {
              label: '计划节点',
              key: 'projectNode',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
            },
            {
              type: "input",
              key: "projectNodeCode",
              label: "计划节点编码",
              value: "",
              disabled: true,
              span: 8,
            },
            {
              type: "input",
              key: "costEstimation",
              label: "成本预估",
              value: "",
              disabled: true,
              span: 8,
            },
            // 预计开始时间
            {
              span: 8,
              label: '预计开始时间',
              key: 'expectedStartTime',
              type: 'date',
              disabled: true,
            },
            // 期望完成日期
            {
              span: 8,
              label: '期望完成日期',
              key: 'expectedEndTime',
              type: 'date',
              disabled: true,
            },
            // 完成情况	Checkbox	默认为“N”，不可编辑
            {
              span: 8,
              type: "radio",
              label: "完成情况",
              value: "N",
              button: false,
              border: false,
              disabled: true,
              key: "completionStatus",
              options: [
                {
                  value: "N",
                  label: "未完成",
                  disabled: false
                },
                {
                  value: "Y",
                  label: "已完成",
                  disabled: false
                }
              ],
            },
            // 备注
            {
              span: 18,
              type: "input",
              key: "remark",
              label: "备注",
              disable: false,
              subtype: 'textarea',
              readonly: false,
              value: "",
              placeholder: "请输入备注",
            }
          ],
          changeFlag: false
        },
        showBtn: false,
        openLook: false,
        form: {},
        editTable: {
          showNumber: false,
          bsPerformanceCompositionList: [
            // 任务节点编号	文本
            {
              label: '任务节点编号',
              prop: 'taskNodeCode',
            },
            // 任务内容	文本
            {
              label: '任务内容',
              prop: 'taskContent',
              editRender: {type: 'default', name: 'ElInput'}
            },
            // 具体工作	文本
            {
              label: '具体工作',
              prop: 'concreteWork',
              editRender: {type: 'default', name: 'ElInput'}
            },
            {
              label: '任务接收人',
              prop: 'taskReceiverObj',
              editRender: {type: 'default'}
            },
            {
              label: '可支配人天',
              prop: 'disposableHumanNature',
              editRender: {type: 'default', name: 'ElInputNumber'}
            },
            {
              label: '计划开始日期',
              prop: 'plannedStartTime',
              formatter: this.formatter,
              editRender: { name: 'ElDatePicker', props: { type: 'date', valueFormat: 'timestamp' } }
            },
            {
              label: '计划完成日期',
              prop: 'plannedEndTime',
              formatter: this.formatter,
              editRender: { name: 'ElDatePicker', props: { type: 'date', valueFormat: 'timestamp' } }
            },
            {
              label: '任务状态',
              prop: 'taskState',
            },
            // 备注	文本
            {
              label: '备注',
              prop: 'remark',
              editRender: {
                type: 'textarea',
                name: 'ElInput',
              }
            }
          ],
        },
        projecCode: '',
      }
    },
    created() {
      this.initData()
      this.isEdit = this.$route.query.isEdit
    },
    watch: {
      tableData: {
        handler() {
          const index = this.tableData.findIndex(item => item.taskState === '已完成')
          if (index !== -1) {
            this.form.completionStatus = 'Y'
          }
        },
        deep: true,
      },
    },
    methods: {
      handleProjectNode(projectNodeId) {
        findProjectNodeInfo(projectNodeId, this.projecCode).then(res => {
          if (res.code === 200) {
            this.form.expectedStartTime = res.data.predictStartTime
            this.form.expectedEndTime = res.data.expectCompletionTime
            if (res.data.milestoneNodeEntity) {
              this.form.projectStage = res.data.milestoneNodeEntity.bsMilestoneNode
            }
            this.form.projectNodeCode = res.data.code
            this.form.costEstimation = res.data.costEstimation
          }
        })
      },
      handleProjectId(data) {
        this.projecCode = data
        const index = this.formConfig.formItemList.findIndex(item => item.key === 'projectNode')
        this.formConfig.formItemList[index].url = `/bizTaskDecomposition/findProjectNode/${data}`
        this.formConfig.changeFlag = !this.formConfig.changeFlag
      },
      initData() {
        if (this.$route.query.id) {
          const id = this.$route.query.id
          queryById(id).then(res => {
            if (res.code === 200) {
              const data = res.data
              if (data.bizTaskDecomposition.bsProject) {
                this.handleProjectId(data.bizTaskDecomposition.bsProject.code)
                if (data.bizTaskDecomposition.bsProjectNode) {
                  this.projecCode = data.bizTaskDecomposition.bsProject.code
                  this.handleProjectNode(data.bizTaskDecomposition.bsProjectNode.id)
                }
              }
              this.form = data.bizTaskDecomposition
              this.form.projectId = this.form.bsProject
              this.form.projectNode = this.form.bsProjectNode
              this.form.projectStage = this.form.bsMilestoneNode
              data.bizJobContentDecompositionList.forEach(item => {
                item.taskReceiverObj = item.taskReceiverPerson
              })
              this.tableData = data.bizJobContentDecompositionList
            }
          })
        } else {
          this.form.code = getDocumentCode('RWFJ')
        }
      },
      formatter(val) {
        if (val) {
          const date = new Date(val)
          return parseTime(date,"{y}-{m}-{d}")
        }
      },
      save(status) {
        if (this.form.projectId) {
          this.form.projectId = this.form.projectId.code
        }
        if (this.form.projectNode) {
          this.form.projectNode = this.form.projectNode.id
        }
        if (this.form.projectStage) {
          this.form.projectStage = this.form.projectStage.id
        }
        this.form.billState = status
        if (this.form.id) {
          edit({
            bizTaskDecomposition: this.form,
            bizJobContentDecompositionList: this.tableData,
          }).then(res => {
            this.$message.success("修改成功！")
          })
        } else {
          add({
            bizTaskDecomposition: this.form,
            bizJobContentDecompositionList: this.tableData,
          }).then(res => {
            this.$message.success('保存成功！')
          })
        }
        this.$router.push('/bill/taskDecomposition')
      },
      submit(status) {
        if (this.form.projectId) {
          this.form.projectId = this.form.projectId.code
        }
        if (this.form.projectNode) {
          this.form.projectNode = this.form.projectNode.id
        }
        if (this.form.projectStage) {
          this.form.projectStage = this.form.projectStage.id
        }
        this.form.commitTime = new Date().getTime()
        this.form.billState = status
        if (this.form.id) {
          edit({
            bizTaskDecomposition: this.form,
            bizJobContentDecompositionList: this.tableData,
          }).then(res => {
            this.$message.success("修改成功！")
          })
        } else {
          add({
            bizTaskDecomposition: this.form,
            bizJobContentDecompositionList: this.tableData,
          }).then(res => {
            this.$message.success('保存成功！')
          })
        }
        this.$router.push('/bill/taskDecomposition')
      },
      cancel() {
        this.$router.push('/bill/taskDecomposition')
      },
      // 绩效组成删除
      subDelete(id, scope) {
        if (!id) {
          this.$refs.delRew.deleteRows(scope.row)
        }
        delForm(id).then(res => {
          if (res.code === 200) {
            this.$refs[scope.$index].doClose()
            this.$notify({
              title: '删除成功',
              type: 'success',
              duration: 2500
            });
            this.tableData.splice(scope.$index, 1)
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
 @import '@/views/bill/mixins/common.scss'
</style>